import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'

// require('./mock');
import {
	VueAxios
} from "@/utils/request"
// import Avue from '@smallwei/avue'
// import '@smallwei/avue/lib/index.css'

// import '@/views/visual/dataScreen/echart/mock/'

import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import 'ant-design-vue/dist/antd.less'; // or 'ant-design-vue/dist/antd.less'
// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';


// import '@/views/visual/dataScreen/js/utils/es6'


import '@/permission' // permission control
import '@/utils/filter' // base filter
import Print from 'vue-print-nb-jeecg'
/*import '@babel/polyfill'*/
import VueApexCharts from 'vue-apexcharts'

// import '@/views/visual/dataScreen/theme/index.js'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

// import './assets/avue-preview.css'
import {
	ACCESS_TOKEN,
	DEFAULT_COLOR,
	DEFAULT_THEME,
	DEFAULT_LAYOUT_MODE,
	DEFAULT_COLOR_WEAK,
	SIDEBAR_TYPE,
	DEFAULT_FIXED_HEADER,
	DEFAULT_FIXED_HEADER_HIDDEN,
	DEFAULT_FIXED_SIDEMENU,
	DEFAULT_CONTENT_WIDTH_TYPE,
	DEFAULT_MULTI_PAGE
} from "@/store/mutation-types"
import config from '@/defaultSettings'
import VueAMap from 'vue-amap' //注意不要和 AMap原始名称覆盖
// import dataV from '@jiaminghi/data-view'
// Vue.use(dataV)
// Vue.use(Avue, {
//   size: 'mini'
// });
setTimeout(() => {
  Vue.use(VueAMap)
}, 0)
VueAMap.initAMapApiLoader({
	// 高德的key
	key: 'fff9f6d9570cff54e05b6bd3b1639fb0',
	// 插件集合
	plugin: [
		'AMap.MapType',
		'AMap.DistrictSearch',
		'AMap.Geolocation',
		'AMap.Autocomplete',
		'AMap.PlaceSearch',
		'AMap.Scale',
		'AMap.OverView',
		'AMap.ToolBar',
		'AMap.MapType',
		'AMap.PolyEditor',
		'AMap.CircleEditor',
    'AMap.MoveAnimation'
	],
	v: '1.4.15',
	uiVersion: '1.0.11'
})
console.log('initmap')

// 风场引用 leaflet CSS
// import L from 'leaflet'
// import 'leaflet-velocity/dist/leaflet-velocity.css'
// import 'leaflet-velocity/dist/leaflet-velocity'


import JDictSelectTag from './components/dict/index.js'
import ScsDictSelectTag from './components/dict/scsindex.js'
import hasPermission from '@/utils/hasPermission'
import vueBus from '@/utils/vueBus';
import JeecgComponents from '@/components/jeecg/index'
import echarts from 'echarts'
import VueJsonp from 'vue-jsonp'
let options = {
	zoomEl: true, //控制是否显示放大缩小按钮
	counterEl: true, //控制是否显示左上角图片数量按钮
	clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
	shareEl: false, //控制是否显示分享按钮
}
//在main.js中加入下面代码
// import 'mars3d/dist/mars3d.css'
// import * as mars3d from 'mars3d'
//
// //导入mars3d插件（按需使用，需要先npm install）
// import 'mars3d-space'
//
// //可以绑定下vue原型链，可以全局使用
// Vue.prototype.mars3d = mars3d;


Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$website = window.$website;
import scroll from 'vue-seamless-scroll'
Vue.use(VueJsonp)
Vue.use(scroll)
Vue.use(Storage, config.storageOptions)
Vue.use(ElementUI)
Vue.use(Antd)
Vue.use(VueAxios, router)
Vue.use(Viser)
Vue.use(hasPermission)
Vue.use(JDictSelectTag)
Vue.use(ScsDictSelectTag)
Vue.use(Print)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(preview, options)
Vue.use(vueBus);
Vue.use(JeecgComponents);
// 在线数据导出中心(全局单实例, 挂在GlobalLayout)
import { CreateExportDialog } from '@/components/onlineExport'
Vue.component('CreateExportDialog', CreateExportDialog)
window.sessionStorage.setItem('token', Vue.ls.get(ACCESS_TOKEN))
Vue.prototype.$notification_custom = (config)=>{
  config.key=config.key || 'notification'
  Vue.prototype.$notification[config.type || 'success']({
    ...config
  })
}
Vue.prototype.$message_custom = (content,type,duration)=>{
  Vue.prototype.$message.destroy();
  Vue.prototype.$message[type || 'success'](
    content,
    duration
  )
}
// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
	if (key === 'fullName' || key === 'treeSt' || key === 'siteId' || key === 'siteType' || key === 'siteName' || key === 'siteAreaId' || key === 'siteAreaName' || key ===
		'sites' || key==='treeCategory' || key === 'pipeId' || key === 'projectId' || key === 'projectName' || key === 'projectSiteId' || key === 'areaId') {

		// 创建一个StorageEvent事件
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				sessionStorage.setItem(k, val);

				// 初始化创建的事件
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

				// 派发对象
				window.dispatchEvent(newStorageEvent)
			}
		}
		return storage.setItem(key, newVal);
	}
}
// 全局获取缓存数据
Vue.prototype.resetSetLocalItem = function (key, newVal) {
	if (key === 'treeSt') {

		// 创建一个StorageEvent事件
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				localStorage.setItem(k, val);

				// 初始化创建的事件
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

				// 派发对象
				window.dispatchEvent(newStorageEvent)
			}
		}
		return storage.setItem(key, newVal);
	}
}
new Vue({
	router,
	store,
	mounted() {
		store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
		store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
		store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
		store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
		store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
		store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
		store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
		store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
		store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
		store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
		store.commit('SET_MULTI_PAGE', Vue.ls.get(DEFAULT_MULTI_PAGE, true))
	},
	render: h => h(App)
}).$mount('#app')
